/**
 * @author Vibhor <vibhor.sharma@314ecorp.com>
 * @description React Hook useSearchCodes
 */
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import _ from 'lodash';

import QUERY_KEYS from 'app-constants/queryKeys';
import api from 'client/index';

/**
 * use search codes hook
 * @returns {UseQueryResult} useSearchCodes
 */
const useSearchCodes = (
	searchModel: CodeExplorer.ICodeSetSearch,
	pageNumber?: number,
	pageSize?: number,
): UseQueryResult<CodeExplorer.ICodeSetSearchResult> => {
	return useQuery({
		queryKey: [QUERY_KEYS.searchCodes, searchModel, pageNumber, pageSize],
		queryFn: async () => {
			const { data } = await api.CodeExplorerApi.codeSearch({ codeSetSearch: searchModel, pgNum: pageNumber, pgSize: pageSize });
			return data;
		},
		enabled: _.size(searchModel.searchterm) >= 2,
	});
};

export default useSearchCodes;
